module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBold.abbaa95.woff2";